import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Col, Container, Row, Button } from "react-bootstrap";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { useNavigate, useParams, Link } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import { FaEdit } from "react-icons/fa";

const ViewPartnerLead = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const getLeadApi = Api({
    url: `admin/service/lead/${id}`,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const leadResponse = await getLeadApi.fetchDataBySingleId();
        if (leadResponse?.data?.serviceLead) {
          setInitialData(leadResponse.data.serviceLead);
        } else {
          showToast("Failed to fetch lead details", { type: "error" });
          navigate("/partner-leads");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        showToast("Error loading data", { type: "error" });
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Partner Network", link: "/partners" },
    { label: "Partner Leads", link: "/partner-leads" },
    { label: "View Partner Lead", link: "", active: true },
  ];

  if (isLoading || !initialData) {
    return (
      <Container fluid style={{ marginTop: "2rem", display: "flex", justifyContent: "center" }}>
        <Spinner loading={true} />
      </Container>
    );
  }

  return (
    <>
      <Notification />
      <Container fluid style={{ marginTop: "2rem", padding: "0rem 4rem" }}>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <SingleDetailHeader
                header="View Partner Lead"
                description="View partner lead details here."
              />
              <Link to={`/partner-leads/edit/${id}`} className="btn btn-primary d-flex align-items-center">
                <FaEdit className="me-2" /> Edit Profile
              </Link>
            </div>
            
            <div className="card p-4 shadow-sm border-0 mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
              <Row className="mb-4">
                <Col md={6}>
                  <h6 className="text-muted mb-1">First Name</h6>
                  <p className="fs-5">{initialData.first_name || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">Last Name</h6>
                  <p className="fs-5">{initialData.last_name || "N/A"}</p>
                </Col>
              </Row>
              
              <Row className="mb-4">
                <Col md={6}>
                  <h6 className="text-muted mb-1">Mobile Number</h6>
                  <p className="fs-5">{initialData.mobile_number || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">Email Address</h6>
                  <p className="fs-5">{initialData.email || "N/A"}</p>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={6}>
                  <h6 className="text-muted mb-1">City</h6>
                  <p className="fs-5">{initialData.city || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">State</h6>
                  <p className="fs-5">{initialData.state || "N/A"}</p>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h6 className="text-muted mb-1">Associated Partner</h6>
                  <p className="fs-5">{initialData.associated_partner?.name || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">Status</h6>
                  <span className={`badge fs-6 ${initialData.status === 'COMPLETED' ? 'bg-success' : initialData.status === 'REJECTED' ? 'bg-danger' : initialData.status === 'INPROGRESS' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                    {initialData.status || "PENDING"}
                  </span>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ViewPartnerLead;
